<!-- 答题闯关 -->
<template>
    <div class="canwser">
        <div class="canwser-message-btn" @click="openAnwser">答题闯关</div>

        <div class="canwser-content" v-if="canwserBoxShow">
            <div class="canwser-content_bg"></div>

            <Cquestion @close="hanldeClose" @getMedal="handleGetMedal" @showVideo="showVideo" />
        </div>

        <!-- 讲解视频 -->
        <videoHotspot class="canswer-video" v-if="videoShow" :isAnswer="true" @closeVideo="closeVideo" :guid="guid" />

        <!-- 奖牌 -->
        <goldMedal v-if="showMedal" @close="handleCloseMedal" :data="medalData" />
    </div>
</template>
  
<script>
import videoHotspot from "@/components/videoHotspot";
import Cquestion from './cquestion.vue';
import goldMedal from './goldMedal';

export default {
    name: 'canwser',
    components: {
        Cquestion,
        goldMedal,
        videoHotspot
    },
    data() {
        return {
            canwserBoxShow: false,
            showMedal: false,
            medalData: {
                type: 'bronze' // gold: 金牌、sliver：银牌、bronze：铜牌
            },
            videoShow: false,
            guid: '',
            showCanswer: false, // 展示答题闯关界面
            audioState: ""
        }
    },
    methods: {
        closeMessage() {
            this.canwserBoxShow = false;
        },
        // 打开事件
        openAnwser() {
            // 首次先打开一个视频
            this.videoShow = true;
            this.guid = 'bc7cdb00f96646eba7c328b149616465';
            this.showCanswer = true;
            // this.canwserBoxShow = true;
            this.audioState = sessionStorage.bgmusic
            sessionStorage.bgmusic = "pause"
            var audio = document.querySelector("#audio");

            if (!audio.paused) {
                audio.pause();
            }
        },
        // 关闭事件
        hanldeClose() {
            this.canwserBoxShow = false;
    
            sessionStorage.bgmusic = this.audioState
            var audio = document.querySelector("#audio");

            if (sessionStorage.bgmusic == "play" && sessionStorage.bgmusicEnd == "false") {
                audio.play();
                audio.addEventListener("ended",function(){
            sessionStorage.bgmusicEnd = "true"
          })
            }
        },
        // 获得奖牌
        handleGetMedal(type) {
            this.showMedal = true;
            this.medalData.type = type;
        },
        // 关闭奖牌弹窗
        handleCloseMedal() {
            this.showMedal = false;
            this.hanldeClose()
        },
        // 关闭讲解视频事件
        closeVideo() {
            if (this.showCanswer) {
                this.canwserBoxShow = true;
                this.showCanswer = false;
            }

            this.videoShow = false;
            var audio = document.querySelector("#audio");
            if (audio.paused && sessionStorage.bgmusic == "play" && sessionStorage.bgmusicEnd == "false") {
                audio.play();
                audio.addEventListener("ended",function(){
            sessionStorage.bgmusicEnd = "true"
          })
            }
        },
        // 打开讲解视频事件
        showVideo(guid) {
            this.guid = guid;
            this.videoShow = true;
            var audio = document.querySelector("#audio");

            if (audio.paused) {
            } else {
                audio.pause();
            }
        },

    },

}
</script>
  
<style lang="scss" scoped>
@mixin background-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.canwser {
    .canwser-content {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 100;
    }

    .canwser-message-btn {
        width: 182px;
        height: 62px;
        line-height: 55px;
        cursor: pointer;
        text-align: center;
        color: #ffffff;
        font-size: 20px;
        position: absolute;
        right: 84px;
        bottom: 60px;
        background-image: url("~@/assets/img/btn-bg.png");
        @include background-com();
    }

    .canwser-content_bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.56);
        position: absolute;
        left: 0;
        top: 0;

    }

    .canswer-video {
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 100;
    }
}
</style>